export const StateToObj = (state)=>{
  return JSON.parse(JSON.stringify(state))
}